import { memo } from 'react'
import { CrawlDelayBoxInput } from '../../inputs/crawl-delay-input'

type CrawlDelayProps = {
  url: string
  crawlDelay?: number
  activeSubscription?: boolean
  tooltip?: boolean
}

export const CrawlDelayBoxWrapper = ({
  url,
  activeSubscription,
  translation,
}: CrawlDelayProps & { translation?: string }) => {
  return (
    <CrawlDelayBoxInput
      value={undefined}
      activeSubscription={activeSubscription}
      url={url}
      translation={translation}
    />
  )
}

export const CrawlDelayBoxMock = memo(CrawlDelayBoxWrapper)
